import React, { useState, useMemo, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  TextField,
  Box,
  FormControl,
  InputLabel,
  TableFooter,
  TablePagination,
  Button,
  IconButton,
  Tooltip,
  Tab,
  Tabs,
} from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { InputTextarea } from "primereact/inputtextarea";
import RulePage from "./RulesPage";
import { useLoader } from "../common/LoaderContext";
import {
  download_Rulebook,
  getRulebookData,
} from "../services/dashboard.services";
import { useLocation, useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface DataRow {
  version: string;
  datemodified: string;
  empType: string;
  instruction: string;
  rules: string;
}

type Rule = {
  payScaleType: string;
  ruleNumber: string;
  name: string;
  description: string;
  warning?: string;
};

const Rulebook = () => {
  const { showLoader, hideLoader } = useLoader();
  // const { rulebookData, setRulebook } = React.useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const rulebookData: any = state;

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const rulebook = await getRulebookData();
  //       setRulebook(rulebook);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);
  ///Table Data ----

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      maxWidth: 221,
      fontSize: "12px",
      padding: "8px 12px",
    },
  }));

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [payScaleTypeFilter, setPayScaleTypeFilter] = useState("All");
  const [personNoFilter, setPersonNoFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Pagination slice
  const pagedData = useMemo(() => {
    const start = page * rowsPerPage;
    return rulebookData.slice(start, start + rowsPerPage);
  }, [rulebookData, page, rowsPerPage]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleNewRulebook = () => {
    navigate("/rule");
  };
  const handleDownloadRule = async (row: any) => {
    if (row.version.includes("(current version)")) {
      row.version = row.version.replace(" (current version)", "");
    }

    const { blob, filename } = await download_Rulebook(row.version);

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || "Rulebook.zip");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  };

  const handleClearFilters = () => {
    setPayScaleTypeFilter("All");
    setStatusFilter("All");
    setPersonNoFilter("All");
    setSearchText("");
    setPage(0);
  };

  return (
    <>
      <div
        className="page-header-container"
        style={{ borderBottom: "1px solid #212B2E" }}
      >
        <div className="left-section">
          <div className="page-heading-section">
            <label className="page-heading">Rulebook</label>
            <p className="page-subheading">Version history of rules</p>
          </div>
        </div>
        <div className="right-section">
          <Button
            className="right-button"
            variant="contained"
            startIcon={<img src="./icons/edit_white.svg" alt="Edit" />}
            sx={{ textTransform: "none", backgroundColor: "#007CB0", marginRight: '16px' }}
            onClick={() => navigate("/rule", { state: { activeStep: 1 } })}
          >
            Manage Rules
          </Button>
          <Button
            className="right-button"
            variant="contained"
            startIcon={<img src="./icons/plus_white.svg" alt="Add" />}
            sx={{
              textTransform: "none",
              backgroundColor: "#007CB0",
              width: "194px !important",
            }}
            onClick={handleNewRulebook}
          >
            Add New Rulebook
          </Button>
        </div>
      </div>
      <Box sx={{ padding: "0px 72px 72px 72px" }}>
        <div className="card dark-table">
          <div
            style={{
              paddingTop: "32px",
              color: "#fff",
            }}
          >
            {/* Filters and Search Top Bar */}

            <TableContainer sx={{ bgcolor: "#0F1116", borderTop: "none",borderRadius:'8px' }}>
              <Table className="manage-rules-tbl">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#1C1E22" }}>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "14px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      Rule version
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "14px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      Date Modified
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "14px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      Pay scale types
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "14px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      Instructions
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "14px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      Rules
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "14px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pagedData.map((row: any, index: any) => (
                    <TableRow
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#26292E" : "#1C1E22",
                      }}
                    >
                      <TableCell
                        sx={{
                          color: "#BFC1C2",
                          fontWeight: 400,
                          fontSize: "16px",
                          borderBottom: "none",
                          borderRight: "1px solid #2F3337",
                        }}
                      >
                        {row.version}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#BFC1C2",
                          fontWeight: 400,
                          fontSize: "16px",
                          borderBottom: "none",
                          borderRight: "1px solid #2F3337",
                        }}
                      >
                        {row.modified_at}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#BFC1C2",
                          fontWeight: 400,
                          fontSize: "16px",
                          borderBottom: "none",
                          borderRight: "1px solid #2F3337",
                        }}
                      >
                        {Array.isArray(row.type) ? row.type.join(", ") : row.type}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#BFC1C2",
                          fontWeight: 400,
                          fontSize: "16px",
                          borderBottom: "none",
                          borderRight: "1px solid #2F3337",
                        }}
                      >
                        {row.instruction_count}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#BFC1C2",
                          fontWeight: 400,
                          fontSize: "16px",
                          borderBottom: "none",
                          borderRight: "1px solid #2F3337",
                        }}
                      >
                        {row.rule_count}
                      </TableCell>

                      <TableCell
                        sx={{
                          color: "#BFC1C2",
                          fontWeight: 400,
                          fontSize: "16px",
                          borderBottom: "none",
                          borderRight: "1px solid #2F3337",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <IconButton
                            color="info"
                            size="small"
                            sx={{ justifyContent: "flex-end" }}
                            onClick={() => handleDownloadRule(row)}
                          >
                            <img src="./icons/download.svg" />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                  {rulebookData.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        align="center"
                        sx={{ color: "#aaa" }}
                      >
                        No records found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow sx={{ borderBottom: "none" }}>
                    <TablePagination
                      sx={{
                        color: "#fff",
                        borderBottom: "none",
                        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .css-h7cjts-MuiButtonBase-root-MuiIconButton-root.Mui-disabled":
                          { color: "#fff" },
                        "& .MuiIconButton-root": { color: "#fff" },
                        "& .MuiSelect-select": { color: "#fff" },
                        alignItems: "center",
                      }}
                      rowsPerPageOptions={[5, 10, 25]}
                      count={rulebookData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      labelRowsPerPage="Rows per page"
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} of ${count}`
                      }
                      showFirstButton
                      showLastButton
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Box>
    </>
  );
};

export default Rulebook;
